import {useErrorHandler} from "@/compositions/useErrorHandler";

export default {
    setup() {
        const {handleError} = useErrorHandler()
        return {
            handleError
        }
    },
}
